import type { ReportColumn } from '../models/column.types'

import { isComparisonChangeColumn } from './comparisonColumns'

/** Which bespoke cell a report column renders through — the presenter's dispatch predicates. */
export function isMediaColumn(column: ReportColumn): boolean {
  return column.isImage === true || column.sub_type === 'image'
}

export function isBadgeColumn(column: ReportColumn): boolean {
  return column.sub_type === 'badge'
}

export function isStatusColumn(column: ReportColumn): boolean {
  return (
    column.sub_type === 'status' ||
    column.field.includes('status') ||
    column.field.startsWith('is_branded')
  )
}

export function isWindowCellsColumn(column: ReportColumn): boolean {
  return column.sub_type === 'window_cells'
}

export function isChipListColumn(column: ReportColumn): boolean {
  return column.meta?.['chips'] === true
}

export function isPerformanceScoreColumn(column: ReportColumn): boolean {
  return column.field.includes('performance_score')
}

export function isPercentileColumn(column: ReportColumn): boolean {
  return column.field.startsWith('p_')
}

/**
 * A cell can seed an `equals` filter when it holds a dimension value — never a metric, media
 * or comparison delta, and never an empty value (v3 `OrphexTd` `showTdFilter` gate).
 */
export function isFilterableCell(column: ReportColumn, value: unknown): boolean {
  return (
    column.numeric !== true &&
    !isMediaColumn(column) &&
    !isComparisonChangeColumn(column) &&
    value !== null &&
    value !== undefined &&
    value !== ''
  )
}
